module.exports = __webpack_public_path__ + "assets/pdf/CookiesPolicy.715b7d80.pdf";